import { jsx as a } from "react/jsx-runtime";
import { Children as s } from "react";
import { tv as o } from "tailwind-variants";
import { I as m } from "./chunks/index-CgDhSQ6a.js";
const c = o({
  base: [
    "duration-250",
    "col-start-1",
    "opacity-0",
    "row-start-1",
    "transition-opacity",
    "w-full"
  ],
  variants: {
    isActive: {
      true: ["opacity-100"]
    }
  }
});
function u({ activeStep: i, children: r }) {
  return /* @__PURE__ */ a("div", { className: "grid items-center relative tablet:row-span-2", children: s.map(r, (e, t) => /* @__PURE__ */ a(
    m,
    {
      alt: "",
      className: c({ isActive: i === t }),
      height: 1200,
      quality: 100,
      src: e.props.image,
      width: 1200
    },
    t
  )) });
}
export {
  u as default
};
